<template>
  <div>
      <lu-hbox lu-flex>
        <lu-vbox lu-flex>
          <lu-item lu-flex style="white-space: pre-line; line-height: 1.5em;">{{ item.desc }}</lu-item>
          <!-- <lu-item lu-flex class="timestamp" style="line-height: 1.5em;">{{ item.creationDateTime | formatDateFilter }}</lu-item> -->
          <lu-item lu-flex class="timestamp" style="line-height: 1.5em;">{{ getCreationDateTime(item) | formatDateFilter }}</lu-item>
        </lu-vbox>
        <lu-item class='el-icon-close' lu-click style='margin-top:5px;' @click.stop='onClose(item)'></lu-item>
      </lu-hbox>
  </div>
</template>

<script>
import { LuHbox, LuVbox, LuItem } from 'lusis-ui'
import { formatDate } from '@/utils'
import { mapActions } from 'vuex'

export default {
  name: 'NotificationbarItem',
  components: { LuHbox, LuVbox, LuItem },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  filters: {
    formatDateFilter: function (date) {
      return formatDate(date, '/')
    }
  },
  data() {
    return {}
  },
  methods: {
    ...mapActions('user', [ 'setReadNotification' ]),
    getCreationDateTime(item) {
      if (item && item.creationDateTime) {
        return item.creationDateTime.substring(0, 12)
      }
    },
    onClose(item) {
      this.sendReadNotification(item)
    },
    setNotificationState(item) {
      this.setReadNotification(item.alertId, 1)
    },
    sendReadNotification (item) {
      let cond = {
        functionId: 'readNotification',
        parameterList: [
          { paramName: 'id', paramValue: item.alertId }
        ]
      }
      return this.$tango.getFunctionData(cond).then(rep => {
        if (rep.resultCode === 0) {
          this.setNotificationState(item)
        }
        else throw new Error()
      })
    },
  }
}
</script>

<style>
.timestamp {
  font-size: 0.9em;
}
</style>